module.exports = __webpack_public_path__ + "img/logo.bc9ef11b.png";